module.exports = __webpack_public_path__ + "img/male7.484764ef.jpg";